module.exports = __webpack_public_path__ + "static/img/img17.d9952c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img17.png
// module id = 4snP
// module chunks = 1